// ═══════════════════════════════════════════════════════════════
// PlanSelectionView.jsx — Thin wrapper around billing module
// Actual UI lives in src/modules/billing/PlanSelection.jsx
// ═══════════════════════════════════════════════════════════════

import React, { useMemo, useCallback } from 'react';
import PlanSelection from '../modules/billing/PlanSelection.jsx';
import { createStripeAdapter } from '../modules/billing/adapters/StripeAdapter.js';
import { OWL_LOGO } from '../shared.jsx';

function PlanSelectionView({ user, onPlanSelected, onSelectFree, onLogout, cloudFunctionUrl, authUid }) {
  const stripeAdapter = useMemo(() => createStripeAdapter({ cloudFunctionUrl }), [cloudFunctionUrl]);

  // Create a tenant for org plan checkout — returns the tenantId
  const handleCreateTenant = useCallback(async (overrides) => {
    try {
      const result = await stripeAdapter.prepareOrganization(overrides);
      if (!result.tenantId) throw new Error(result.error || 'Organization preparation failed.');
      return result.tenantId;
    } catch (e) {
      console.error('Failed to create tenant:', e);
      return null;
    }
  }, [stripeAdapter]);

  return (
    <PlanSelection
      user={user}
      stripeAdapter={stripeAdapter}
      onPlanSelected={onPlanSelected}
      onSelectFree={onSelectFree}
      onLogout={onLogout}
      onCreateTenant={handleCreateTenant}
      logoUrl={OWL_LOGO}
      authUid={authUid}
    />
  );
}

export default PlanSelectionView;
